var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50456 8.91422C3.55329 8.84518 3.58578 8.77615 3.63857 8.72336C4.23552 8.12235 4.83246 7.5254 5.42941 6.92845C5.79895 6.55891 6.32686 6.55079 6.68016 6.90409C7.02127 7.24114 7.02533 7.78123 6.67204 8.14265C5.81519 9.00762 4.95429 9.86852 4.08933 10.7254C3.71573 11.0949 3.21624 11.0908 2.84264 10.7172C1.97768 9.85634 1.11677 8.99949 0.259931 8.13047C-0.0933645 7.77717 -0.0811819 7.23302 0.263992 6.89597C0.613226 6.55485 1.13708 6.55891 1.49849 6.92033C2.15229 7.56601 2.80609 8.21575 3.50456 8.91422Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43196 2.08578C3.38323 2.15482 3.35074 2.22385 3.29795 2.27664C2.70101 2.87765 2.10406 3.4746 1.50711 4.07155C1.13757 4.44109 0.60966 4.44921 0.256365 4.09591C-0.0847477 3.75886 -0.0888089 3.21876 0.264486 2.85735C1.12133 1.99238 1.98223 1.13148 2.8472 0.274638C3.2208 -0.0949009 3.72028 -0.0908401 4.09388 0.282759C4.95885 1.14366 5.81975 2.00051 6.67659 2.86953C7.02989 3.22283 7.01771 3.76698 6.67253 4.10403C6.3233 4.44515 5.79945 4.44109 5.43803 4.07967C4.78423 3.43399 4.13043 2.78425 3.43196 2.08578Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.ba47b70243a3bfcd97a82960e961d57e.svg";
export { ForwardRef as ReactComponent };